export {
  default as BenefitsPurchaseTickets,
} from './impl/BenefitsPurchaseTickets.jsx';


// WEBPACK FOOTER //
// ./src/components/snippets/ChiefSliderComponent/entities/items/BenefitsPurchaseTickets/index.jsx